import React from 'react'
import styled, { css } from 'styled-components'

export const StyledButton = styled.button`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.96px;
  background-color: transparent;
  border: none;
  width: 100%;
  height: 40px;
  line-height: 40px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  padding: 0 16px;

  border-radius: 8px;
  background-color: var(--cobasi-blue-light-8);
  color: var(--the-white);
  &:focus {
    outline: none;
  }
  ${({ secondary }) => secondary && css`
    background-color: transparent;
    color: var(--cobasi-blue-light-8);
    &:disabled {
      color: var(--gray-9);
      background: transparent;
    }
  `}
  ${({ outline }) => outline && css`
    background-color: transparent;
    border: 1px solid var(--cobasi-blue-light-8);
    color: var(--cobasi-blue-light-8);
  `}
  ${({ disabled }) => disabled && css`
    background-color: var(--silver);
    color: var(--gray-9);
    border: none;
  `}
`
const Button = ({ children, ...rest }) => {
  return <StyledButton {...rest}>{children}</StyledButton>
}

export default Button
